import { createSelector } from "@reduxjs/toolkit";
import {
  MESSAGE_CHANNEL,
  MESSAGE_STATUSES,
  MESSAGE_TYPES,
} from "../../../packages/constants";
import { MessageText } from "../types";
import { selectChatMessages } from "./select-chat-messages";

const DEFAULT_MESSAGE: MessageText = {
  id: "",
  traceId: "",
  authorId: "",
  date: "",
  editDate: "",
  type: MESSAGE_TYPES.TEXT,
  status: MESSAGE_STATUSES.RECEIVED,
  replyMessage: null,
  channel: MESSAGE_CHANNEL.REQUEST,
  content: {
    text: "",
    entities: [],
  },
};

export const selectLastMessage = createSelector(
  selectChatMessages,
  // TODO сделать шаблон пустого сообщения
  (messages) => messages.slice(-1)[0] || DEFAULT_MESSAGE
);
